import { makeStyles } from '@material-ui/styles';
import { VisibilityOffOutlined, VisibilityOutlined } from '@material-ui/icons';
import S from 'views/Pages/AuthStyled';

const useStyles = makeStyles({
  wrapper: {
    marginBottom: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    borderBottom: '1px solid #D2D2D2',
  },
  inputParent: {
    display: 'flex',
    flexDirection: 'row',
  },
  input: {
    width: '95%',
    border: 'none',
  },
  button: {
    cursor: 'pointer',
    border: 'none',
    background: 'white',
  },
  icon: {
    color: '#BDBDBD',
    marginTop: '6px',
  },
  authWrapper: {
    marginBottom: '16px',
  },
});

const PasswordInput = ({
  label,
  name,
  value,
  showPasswordKey,
  autoComplete,
  state,
  setState,
  focusKey,
  repeatInput,
  variant,
}) => {
  const classes = useStyles();
  const iconStyles = { color: '#BDBDBD', marginTop: '6px' };
  const isFramedInput = variant === 'framedInput';
  const inputValue = value ?? state?.[name] ?? '';

  // eslint-disable-next-line no-shadow -- FIXME
  const modifyState = (key, value) => {
    setState(prev => ({
      ...prev,
      [key]: value,
    }));
  };

  const getBorderBottom = () => {
    const focusedPasswordRepeat = state?.focusedPasswordRepeat || false;
    const plainPassword = state?.plainPassword || '';
    const plainPasswordMatch = state?.plainPasswordMatch || '';

    if (!focusedPasswordRepeat || plainPasswordMatch === '') {
      return '1px solid #D2D2D2';
    }

    return plainPassword === plainPasswordMatch
      ? '2px solid #4CAF50'
      : '2px solid #F44336';
  };

  if (isFramedInput) {
    return (
      <div className={classes.authWrapper}>
        <S.AuthInput>
          <input
            type={state[showPasswordKey] ? 'text' : 'password'}
            className={`form__input ${inputValue ? 'label-top' : ''}`}
            autoComplete={autoComplete}
            name={name}
            id={name}
            placeholder=" "
            value={inputValue}
            onChange={e => {
              modifyState(name, e.target.value);
            }}
            onFocus={() => focusKey && modifyState(focusKey, true)}
            onBlur={() => focusKey && modifyState(focusKey, false)}
          />
          <label className="form__label" htmlFor={name}>
            {label}
          </label>
          <button
            type="button"
            className="toggle-password"
            onClick={() =>
              modifyState(showPasswordKey, !state[showPasswordKey])
            }
          >
            {state[showPasswordKey] ? (
              <VisibilityOutlined style={iconStyles} />
            ) : (
              <VisibilityOffOutlined style={iconStyles} />
            )}
          </button>
        </S.AuthInput>
      </div>
    );
  }

  return (
    <div
      className={classes.wrapper}
      style={
        repeatInput && {
          borderBottom: getBorderBottom(),
        }
      }
    >
      <label htmlFor={name}>{label}</label>
      <div className={classes.inputParent}>
        <input
          type={state[showPasswordKey] ? 'text' : 'password'}
          className={classes.input}
          autoComplete={autoComplete}
          name={name}
          placeholder=" "
          value={inputValue}
          onChange={e => {
            modifyState(name, e.target.value);
          }}
          onFocus={() => focusKey && modifyState(focusKey, true)}
          onBlur={() => focusKey && modifyState(focusKey, false)}
        />
        <button
          type="button"
          onClick={() =>
            modifyState([showPasswordKey], !state[showPasswordKey])
          }
          className={classes.button}
        >
          {state[showPasswordKey] ? (
            <VisibilityOutlined className={classes.icon} />
          ) : (
            <VisibilityOffOutlined className={classes.icon} />
          )}
        </button>
      </div>
    </div>
  );
};

export default PasswordInput;
